export default "__VITE_ASSET__B5BLRk2q__"